var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"atom-image-title",style:({ 'background-image': `url(${_vm.image})` })},[_c('div',{staticClass:"background-gradient"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }